import React from 'react';
import { observer } from 'mobx-react';
import { ConnectionOtherFormVM } from './connection-other-form.viewmodel';
import { FormattedMessage } from 'react-intl';
import { FieldKey, FORM_CONFIG } from './connection-other-form.config';
import { CommonPopupBodyFooterLayout } from '../../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { FormFieldProps, FormVmItemConfigType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { FormInputType } from '../../../../../../_events/_manage-event/shared/connections-list/_connection-form/connection-form.viewmodel';
import { cancelText, submitText } from '../../../../../../../constants/common-labels.constants';
import { FormFieldError } from '../../../../../../global/form/form-field-input/form-field-error';

export type ConnectionTemplateFormPresentationProps = {
    vm: ConnectionOtherFormVM;
};

interface IFieldItem {
    item: FormFieldProps;
    keyValue: FieldKey;
}

export const ConnectionOtherFormPresentation = observer(({ vm }: ConnectionTemplateFormPresentationProps): JSX.Element => {
    const getFields = (): IFieldItem[] => {
        return Object.keys(FieldKey).map(key => {
            return {
                item: vm.getFormFieldPropsByKey(FieldKey[key]),
                keyValue: FieldKey[key]
            };
        });
    };

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form oe-form--connection-template'>
                    {getFields().map(field => {
                        const { item, keyValue } = field;
                        let element;
                        const configItem = FORM_CONFIG[keyValue] as FormVmItemConfigType;
                        const fieldProps = {
                            value: item.value as string,
                            type: 'text',
                            onChange: e => item.setValue(e.target.value),
                            onBlur: item.setTouched,
                            className: 'oe-form-field__control',
                            readOnly: configItem.readOnly
                        };
                        const fieldType = configItem.fieldTypeHTML || FormInputType.TextInput;
                        if (fieldType === FormInputType.Select) {
                            const optionItems = configItem.valueOptions.map(option => {
                                return option != null && typeof option === 'object'
                                    ? <option value={option.value} key={String(option.value)}>{option.label || option.value || ''}</option>
                                    : <option value={String(option)} key={String(option)}>{option || ''}</option>;
                            });

                            element = React.createElement(fieldType, fieldProps, optionItems);
                        } else {
                            element = React.createElement(fieldType, fieldProps);
                        };


                        return (
                            <FormField
                                className='m-bottom-20px'
                                label={<FormattedMessage {...configItem.labelDescriptor} />}
                                key={keyValue}
                            >
                                <>
                                    {element}
                                    {<FormFieldError field={item} labelDescriptor={configItem.labelDescriptor} />}
                                </>
                            </FormField>
                        );

                    })}
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={submitText(vm.isEditMode)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={() => vm.submitForm()}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />
    );
});
